import { useState, useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Doctors from "./components/Doctors";
import Services from "./components/Services";
import Gallery from "./components/Gallery";
import FAQ from "./components/FAQ";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import FloatingButtons from "./components/FloatingButtons";
import BackToTop from "./components/BackToTop";
import Loader from "./components/Loader";

function App() {
  const [loading, setLoading] = useState(true);
  const [selectedBranch, setSelectedBranch] = useState(() => {
    const saved = localStorage.getItem("selectedBranch");
    return saved || "mangalam";
  });

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2500);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    localStorage.setItem("selectedBranch", selectedBranch);
  }, [selectedBranch]);

  return (
    <Router>
      {loading && <Loader />}
      <div className="App" style={{ visibility: loading ? "hidden" : "visible" }}>
        <Navbar selectedBranch={selectedBranch} setSelectedBranch={setSelectedBranch} />
        <Hero isPageLoaded={!loading} selectedBranch={selectedBranch} />
        <About />
        <Doctors />
        <Services />
        <Gallery />
        <FAQ />
        <Contact selectedBranch={selectedBranch} setSelectedBranch={setSelectedBranch} />
        <Footer selectedBranch={selectedBranch} />
        <FloatingButtons selectedBranch={selectedBranch} />
        <BackToTop />
      </div>
    </Router>
  );
}

export default App;